/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddAbsenceRequest,
  AddDutyRosterShift,
  DepartmentDutyRosterGetParams,
  DepartmentDutyRosterResult,
  DutyShiftDto,
  EditDutyRosterShift,
  GetFormulaResultsParams,
  GetShiftParams,
  StringFormulaResultDictionaryWrapper
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getDepartmentDutyRosterGetUrl = (params?: DepartmentDutyRosterGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["departmentIds","workareaIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DepartmentDutyRoster/Get?${stringifiedParams}` : `/api/DepartmentDutyRoster/Get`
}

export const departmentDutyRosterGet = async (params?: DepartmentDutyRosterGetParams, options?: RequestInit): Promise<DepartmentDutyRosterResult> => {
  
  return customInstance<DepartmentDutyRosterResult>(getDepartmentDutyRosterGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDepartmentDutyRosterGetQueryKey = (params?: DepartmentDutyRosterGetParams,) => {
    return [
    `/api/DepartmentDutyRoster/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDepartmentDutyRosterGetQueryOptions = <TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDepartmentDutyRosterGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof departmentDutyRosterGet>>> = ({ signal }) => departmentDutyRosterGet(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DepartmentDutyRosterGetQueryResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterGet>>>
export type DepartmentDutyRosterGetQueryError = ErrorType<unknown>


export function useDepartmentDutyRosterGet<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params: undefined |  DepartmentDutyRosterGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof departmentDutyRosterGet>>,
          TError,
          Awaited<ReturnType<typeof departmentDutyRosterGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGet<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof departmentDutyRosterGet>>,
          TError,
          Awaited<ReturnType<typeof departmentDutyRosterGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGet<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDepartmentDutyRosterGet<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDepartmentDutyRosterGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDepartmentDutyRosterGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDepartmentDutyRosterGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof departmentDutyRosterGet>>> = ({ signal }) => departmentDutyRosterGet(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DepartmentDutyRosterGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterGet>>>
export type DepartmentDutyRosterGetSuspenseQueryError = ErrorType<unknown>


export function useDepartmentDutyRosterGetSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params: undefined |  DepartmentDutyRosterGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGetSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGetSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDepartmentDutyRosterGetSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDepartmentDutyRosterGetSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDepartmentDutyRosterAddAbsenceUrl = () => {


  

  return `/api/DepartmentDutyRoster/AddAbsence`
}

export const departmentDutyRosterAddAbsence = async (addAbsenceRequest: AddAbsenceRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getDepartmentDutyRosterAddAbsenceUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addAbsenceRequest,)
  }
);}




export const getDepartmentDutyRosterAddAbsenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>, TError,{data: BodyType<AddAbsenceRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>, TError,{data: BodyType<AddAbsenceRequest>}, TContext> => {

const mutationKey = ['departmentDutyRosterAddAbsence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>, {data: BodyType<AddAbsenceRequest>}> = (props) => {
          const {data} = props ?? {};

          return  departmentDutyRosterAddAbsence(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DepartmentDutyRosterAddAbsenceMutationResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>>
    export type DepartmentDutyRosterAddAbsenceMutationBody = BodyType<AddAbsenceRequest>
    export type DepartmentDutyRosterAddAbsenceMutationError = ErrorType<unknown>

    export const useDepartmentDutyRosterAddAbsence = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>, TError,{data: BodyType<AddAbsenceRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>,
        TError,
        {data: BodyType<AddAbsenceRequest>},
        TContext
      > => {

      const mutationOptions = getDepartmentDutyRosterAddAbsenceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getDepartmentDutyRosterAddShiftUrl = () => {


  

  return `/api/DepartmentDutyRoster/AddShift`
}

export const departmentDutyRosterAddShift = async (addDutyRosterShift: AddDutyRosterShift, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getDepartmentDutyRosterAddShiftUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addDutyRosterShift,)
  }
);}




export const getDepartmentDutyRosterAddShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>, TError,{data: BodyType<AddDutyRosterShift>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>, TError,{data: BodyType<AddDutyRosterShift>}, TContext> => {

const mutationKey = ['departmentDutyRosterAddShift'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>, {data: BodyType<AddDutyRosterShift>}> = (props) => {
          const {data} = props ?? {};

          return  departmentDutyRosterAddShift(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DepartmentDutyRosterAddShiftMutationResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>>
    export type DepartmentDutyRosterAddShiftMutationBody = BodyType<AddDutyRosterShift>
    export type DepartmentDutyRosterAddShiftMutationError = ErrorType<unknown>

    export const useDepartmentDutyRosterAddShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>, TError,{data: BodyType<AddDutyRosterShift>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof departmentDutyRosterAddShift>>,
        TError,
        {data: BodyType<AddDutyRosterShift>},
        TContext
      > => {

      const mutationOptions = getDepartmentDutyRosterAddShiftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getDepartmentDutyRosterEditShiftUrl = () => {


  

  return `/api/DepartmentDutyRoster/EditShift`
}

export const departmentDutyRosterEditShift = async (editDutyRosterShift: EditDutyRosterShift, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getDepartmentDutyRosterEditShiftUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      editDutyRosterShift,)
  }
);}




export const getDepartmentDutyRosterEditShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>, TError,{data: BodyType<EditDutyRosterShift>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>, TError,{data: BodyType<EditDutyRosterShift>}, TContext> => {

const mutationKey = ['departmentDutyRosterEditShift'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>, {data: BodyType<EditDutyRosterShift>}> = (props) => {
          const {data} = props ?? {};

          return  departmentDutyRosterEditShift(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DepartmentDutyRosterEditShiftMutationResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>>
    export type DepartmentDutyRosterEditShiftMutationBody = BodyType<EditDutyRosterShift>
    export type DepartmentDutyRosterEditShiftMutationError = ErrorType<unknown>

    export const useDepartmentDutyRosterEditShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>, TError,{data: BodyType<EditDutyRosterShift>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof departmentDutyRosterEditShift>>,
        TError,
        {data: BodyType<EditDutyRosterShift>},
        TContext
      > => {

      const mutationOptions = getDepartmentDutyRosterEditShiftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetShiftUrl = (params?: GetShiftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DepartmentDutyRoster/GetShift?${stringifiedParams}` : `/api/DepartmentDutyRoster/GetShift`
}

export const getShift = async (params?: GetShiftParams, options?: RequestInit): Promise<DutyShiftDto> => {
  
  return customInstance<DutyShiftDto>(getGetShiftUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetShiftQueryKey = (params?: GetShiftParams,) => {
    return [
    `/api/DepartmentDutyRoster/GetShift`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetShiftQueryOptions = <TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(params?: GetShiftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShift>>> = ({ signal }) => getShift(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetShiftQueryResult = NonNullable<Awaited<ReturnType<typeof getShift>>>
export type GetShiftQueryError = ErrorType<unknown>


export function useGetShift<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params: undefined |  GetShiftParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShift>>,
          TError,
          Awaited<ReturnType<typeof getShift>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetShift<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params?: GetShiftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShift>>,
          TError,
          Awaited<ReturnType<typeof getShift>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetShift<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params?: GetShiftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetShift<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params?: GetShiftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetShiftQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetShiftSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(params?: GetShiftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShift>>> = ({ signal }) => getShift(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetShiftSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getShift>>>
export type GetShiftSuspenseQueryError = ErrorType<unknown>


export function useGetShiftSuspense<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params: undefined |  GetShiftParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetShiftSuspense<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params?: GetShiftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetShiftSuspense<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params?: GetShiftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetShiftSuspense<TData = Awaited<ReturnType<typeof getShift>>, TError = ErrorType<unknown>>(
 params?: GetShiftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetShiftSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetFormulaResultsUrl = (params?: GetFormulaResultsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["contractIds","formulaIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DepartmentDutyRoster/GetFormulaResults?${stringifiedParams}` : `/api/DepartmentDutyRoster/GetFormulaResults`
}

export const getFormulaResults = async (params?: GetFormulaResultsParams, options?: RequestInit): Promise<StringFormulaResultDictionaryWrapper> => {
  
  return customInstance<StringFormulaResultDictionaryWrapper>(getGetFormulaResultsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetFormulaResultsQueryKey = (params?: GetFormulaResultsParams,) => {
    return [
    `/api/DepartmentDutyRoster/GetFormulaResults`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetFormulaResultsQueryOptions = <TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(params?: GetFormulaResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFormulaResultsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFormulaResults>>> = ({ signal }) => getFormulaResults(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFormulaResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getFormulaResults>>>
export type GetFormulaResultsQueryError = ErrorType<unknown>


export function useGetFormulaResults<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFormulaResultsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFormulaResults>>,
          TError,
          Awaited<ReturnType<typeof getFormulaResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFormulaResults<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params?: GetFormulaResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFormulaResults>>,
          TError,
          Awaited<ReturnType<typeof getFormulaResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFormulaResults<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params?: GetFormulaResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFormulaResults<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params?: GetFormulaResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFormulaResultsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetFormulaResultsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(params?: GetFormulaResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFormulaResultsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFormulaResults>>> = ({ signal }) => getFormulaResults(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFormulaResultsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFormulaResults>>>
export type GetFormulaResultsSuspenseQueryError = ErrorType<unknown>


export function useGetFormulaResultsSuspense<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFormulaResultsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFormulaResultsSuspense<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params?: GetFormulaResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFormulaResultsSuspense<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params?: GetFormulaResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFormulaResultsSuspense<TData = Awaited<ReturnType<typeof getFormulaResults>>, TError = ErrorType<unknown>>(
 params?: GetFormulaResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFormulaResultsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



